/** Professional identity for desks and client portals. Buyer/seller state is never stored here. */

import { getAgentProfile } from "./agentProfile";
import { getBrokerProfile } from "./brokerProfile";
import { getAccountSettings } from "./accountSettings";
import { getById } from "../db";

export function resolveProIdentity(session) {
  if (!session?.userId) return null;
  const role = session.role === "broker" ? "broker" : session.role === "agent" ? "agent" : null;
  if (!role) return null;
  const settings = getAccountSettings(session.userId);
  if (role === "broker") {
    const profile = getBrokerProfile(session.userId, session);
    return {
      role,
      userId: session.userId,
      name: profile.broker_name || session.name || "",
      title: profile.broker_title || "Broker",
      license: profile.license || "",
      officeName: profile.office_name || session.office_name || "",
      officeAddress: [profile.office_address, profile.office_city, profile.office_state, profile.office_zip]
        .filter(Boolean)
        .join(", "),
      phone: profile.broker_phone || profile.office_phone || "",
      email: profile.broker_email || session.email || "",
      photo: profile.photo || "",
      displayName: formatAdvisorName(
        profile.broker_name || session.name,
        profile.broker_title,
        settings,
        profile.display_format
      ),
      officeLogo: profile.office_logo || "",
    };
  }
  const profile = getAgentProfile(session.userId, session);
  return {
    role,
    userId: session.userId,
    name: profile.agent_name || session.name || "",
    title: profile.agent_title || "Agent",
    license: profile.dre_license || "",
    officeName: profile.office_name || session.office_name || "",
    officeAddress: [profile.office_address, profile.office_city, profile.office_state, profile.office_zip]
      .filter(Boolean)
      .join(", "),
    phone: profile.agent_phone || profile.office_phone || "",
    email: profile.agent_email || session.email || "",
    photo: profile.photo || "",
    displayName: formatAdvisorName(
      profile.agent_name || session.name,
      profile.agent_title,
      settings,
      profile.display_format
    ),
    officeLogo: profile.office_logo || "",
  };
}

export function resolveAdvisorForClient(agentId) {
  if (!agentId) return null;
  const user = getById("users", agentId);
  if (!user) return null;
  const session = {
    userId: user.id,
    role: user.role_type,
    name: user.name,
    email: user.email,
    office_name: user.office_name,
  };
  return resolveProIdentity(session);
}

function formatAdvisorName(name, title, settings, displayFormat = "name-title") {
  const label = settings.portal.advisorLabel || "Your Advisor";
  const showTitle = settings.portal.showTitle !== false && displayFormat !== "name-only";
  let who = name || title || "Your advisor";
  if (showTitle && title && name) {
    who = displayFormat === "title-name" ? `${title} ${name}` : `${name}, ${title}`;
  } else if (showTitle && title && !name) {
    who = title;
  }
  return `${label}: ${who}`;
}
